/**
 * Returns a random selection of items from an array without duplicates.
 * Uses splice to guarantee uniqueness.
 *
 * @param {Array} items - The source array to select from
 * @param {number} count - Number of items to select
 * @returns {Array} Array of randomly selected items
 */
export const getRandomItems = (items, count) => {
  const copy = [...items];
  const result = [];
  for (let i = 0; i < count && copy.length > 0; i++) {
    const randomIndex = Math.floor(Math.random() * copy.length);
    result.push(copy.splice(randomIndex, 1)[0]);
  }
  return result;
};
